import { render, staticRenderFns } from "./VaultController.vue?vue&type=template&id=4beffd5e&scoped=true&"
import script from "./VaultController.vue?vue&type=script&lang=ts&"
export * from "./VaultController.vue?vue&type=script&lang=ts&"
import style0 from "./VaultController.vue?vue&type=style&index=0&id=4beffd5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beffd5e",
  null
  
)

export default component.exports